import { useUnit } from 'effector-react'
import { AppButton } from '../button'
import { useStyles } from './styles'
// import { $casesList, $userKeys } from '@/entities/cases/model/store'
import { $casesList, $userKeys } from '@/entities/cases'
import { lang } from '@/shared/constants/lang'
import { $userLanguage } from '@/entities/user'
import { Icon } from '../icon'
import { $caseQuery } from '@/entities/navigation/store'

type Props = {
  onClick?: () => void
  keys: number
}

export const OpenBoxButton = (props: Props) => {
  const { onClick, keys } = props
  const userKeys = useUnit($userKeys)
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const _caseId = useUnit($caseQuery)
  const _case = useUnit($casesList)?.find((_case) => _case.id == _caseId)
  const caseName = _caseId ? _case?.name : 'Gamed CASE'

  return (
    <AppButton
      onClick={onClick}
      fullWidth
      className={classes.root}
      data-isenoughkeys={userKeys! >= keys}
      data-casename={caseName}
    >
      <div className={classes.divWrapper}>
        <span className={classes.span}>{lang[userLang].pages.btnTexts.openBox}</span>
      </div>
      <div className={classes.divWrapper}>
        <Icon
          view="gamedKey"
          width={34}
        />
        <span className={classes.span}>
          {userKeys} / {keys}
        </span>
        <span className={classes.span}>{lang[userLang].pages.btnTexts.key}</span>
      </div>
    </AppButton>
  )
}
